/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { CtaBannerFragment } from '@gql'
import { SimpleCta } from '../../../../components/simplecta/SimpleCta'
import { useMediaQuery } from '@material-ui/core'
import { theme } from '../../../../theme'
import {
  CTASubTitle,
  CTASubTitleBold,
  CTATitle,
  InternalCTAWrapper,
  MobileWrapper,
  StyledCTAWrapper,
  TitleWrapper,
} from './styledBannerCta'
import { DesktopLinks, MobileLinks, useCTALinksContext } from './ctaLinks'
import styled from 'styled-components'
import { irem } from '../../../../utils'

export type BannerCTAProps = {
  title: string
  data: CtaBannerFragment[]
}

export const BannerCTAWrapper = styled(StyledCTAWrapper)`
  background: ${props => props.theme.custom.colors.grey};
    
  ${props => props.theme.breakpoints.up('sm')} {
    padding-bottom: ${irem(40)};
  }
`

export const BannerCTA: React.VFC<BannerCTAProps> = ({ title, data }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { selectedCTAFilter } = useCTALinksContext()

  return (
    <BannerCTAWrapper>
      <SimpleCta>
        <InternalCTAWrapper>
          {isMobile ? (
            <MobileWrapper>
              <CTATitle>{title}</CTATitle>
              {typeof selectedCTAFilter === 'undefined' ? (
                <CTASubTitle><CTASubTitleBold>I am...</CTASubTitleBold></CTASubTitle>
              ) : (
                <CTASubTitle>
                  I am <CTASubTitleBold orange>{data?.[selectedCTAFilter]?.ctaLinkTitle}</CTASubTitleBold> {!data?.[selectedCTAFilter]?.prompt || data?.[selectedCTAFilter]?.prompt === 'lookingFor' ? 'looking for...' : (data?.[selectedCTAFilter]?.prompt === 'about' ? 'about...' : '...')}
                </CTASubTitle>
              )}
              <MobileLinks data={data} />
            </MobileWrapper>
          ) : (
            <>
              <TitleWrapper>
                <CTATitle>{title}</CTATitle>
                {typeof selectedCTAFilter === 'undefined' ? (
                  <CTASubTitle><CTASubTitleBold>I am...</CTASubTitleBold></CTASubTitle>
                ) : (
                  <CTASubTitle>
                    I am <CTASubTitleBold orange>{data?.[selectedCTAFilter]?.ctaLinkTitle}</CTASubTitleBold> {!data?.[selectedCTAFilter]?.prompt || data?.[selectedCTAFilter]?.prompt === 'lookingFor' ? 'looking for...' : (data?.[selectedCTAFilter]?.prompt === 'about' ? 'about...' : '...')}
                  </CTASubTitle>
                )}
              </TitleWrapper>
              <DesktopLinks data={data} />
            </>
          )}
        </InternalCTAWrapper>
      </SimpleCta>
    </BannerCTAWrapper>
  )
}
